import styled from 'styled-components';



export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
`;


export const SectionListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionItemContent = styled.div`
`;
